import { ApplicationKibsiClient, DashboardKibsiClient, DeploymentKibsiClient, DetectorKibsiClient, EdgeDeviceKibsiClient, EventKibsiClient, FloorPlanKibsiClient, HistoryKibsiClient, IntegrationKibsiClient, RealtimeDataKibsiClient, SiteKibsiClient, StreamKibsiClient, SubscriptionKibsiClient, TagKibsiClient, TenantKibsiClient, UserKibsiClient, } from './services';
import { TimeKibsiClient } from './time';
/**
 * SDK exposing entity clients.
 */
export class KibsiClientSDK {
    static tokenAuthRequestConfig(token) {
        return {
            headers: {
                Authorization: `Bearer ${token.access_token}`,
            },
        };
    }
    clients = new Map();
    clientParams;
    constructor(sdkParams) {
        this.clientParams = {
            ...sdkParams,
        };
        if (this.clientParams.basePathTemplate.indexOf('{service}') === -1) {
            throw new Error('basePathTemplate must include {service} placeholder.');
        }
    }
    tenants() {
        return this.cacheClient(TenantKibsiClient);
    }
    sites() {
        return this.cacheClient(SiteKibsiClient);
    }
    users() {
        return this.cacheClient(UserKibsiClient);
    }
    integrations() {
        return this.cacheClient(IntegrationKibsiClient);
    }
    deployments() {
        return this.cacheClient(DeploymentKibsiClient);
    }
    events() {
        return this.cacheClient(EventKibsiClient);
    }
    subscriptions() {
        return this.cacheClient(SubscriptionKibsiClient);
    }
    time() {
        return this.cacheClient(TimeKibsiClient);
    }
    streams() {
        return this.cacheClient(StreamKibsiClient);
    }
    detectors() {
        return this.cacheClient(DetectorKibsiClient);
    }
    applications() {
        return this.cacheClient(ApplicationKibsiClient);
    }
    realtimeData() {
        return this.cacheClient(RealtimeDataKibsiClient);
    }
    history() {
        return this.cacheClient(HistoryKibsiClient);
    }
    edgeDevice() {
        return this.cacheClient(EdgeDeviceKibsiClient);
    }
    floorPlan() {
        return this.cacheClient(FloorPlanKibsiClient);
    }
    dashboard() {
        return this.cacheClient(DashboardKibsiClient);
    }
    tag() {
        return this.cacheClient(TagKibsiClient);
    }
    cacheClient(Client) {
        if (!this.clients.has(Client)) {
            this.clientParams.logger?.debug(`Initializing client for ${Client.name}.`);
            this.clients.set(Client, new Client(this.clientParams));
        }
        return this.clients.get(Client);
    }
}
//# sourceMappingURL=sdk.impl.js.map